// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__vHybv","image":"Header_image__2RlGI","name":"Header_name__Y33Z4","info":"Header_info__2PUTt","infoRow":"Header_infoRow__1rqEl"};